import {
    Datagrid,
    List,
    TextField,
    TopToolbar,
    CreateButton,
    useRecordContext,
    Filter,
    TextInput,
} from 'react-admin';
import FormattedDateTimeField from '../../common/FormattedDateTimeField';
import { useEffect, useState } from 'react';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { DownloadIcon, UploadIcon } from 'lucide-react';
import { NoDataSection } from '../../common/NoDataSection';
import { useNavigate } from 'react-router';
import StatusTags from '../../common/StatusTags';

const Actions = ({ openRowId, setOpenRowId }: any) => {
    const record = useRecordContext();
    const isOpen = openRowId === record?.id;

    const handleButtonClick = (e: any) => {
        e.stopPropagation();
        setOpenRowId(isOpen ? null : record?.id);
    };

    useEffect(() => {
        const handleClick = () => setOpenRowId(null);
        if (isOpen) {
            document.addEventListener('click', handleClick);
        }
        return () => {
            document.removeEventListener('click', handleClick);
        };
    }, [isOpen, setOpenRowId]);

    return (
        <div className="relative inline-block">
            <button onClick={handleButtonClick} className="p-2 rounded-full hover:bg-gray-200">
                <MoreVertIcon />
            </button>

            {isOpen && (
                <div
                    className="absolute text-md uppercase text-blue-800 right-0 mt-2 w-48 my-3 bg-white shadow-lg rounded-lg p-2 flex flex-col justify-start text-start gap-2 z-10"
                    onClick={e => e.stopPropagation()}
                >
                    <a
                        href={record?.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:bg-blue-50 py-1 px-2 cursor-pointer flex flex-row gap-2"
                    >
                        <UploadIcon size="20" />
                        Uploaded File
                    </a>
                    {record?.responseUrl && (
                        <a
                            href={record?.responseUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:bg-blue-50 cursor-pointer py-1 px-2 flex flex-row gap-2"
                        >
                            <DownloadIcon size="20" />
                            Response File
                        </a>
                    )}
                </div>
            )}
        </div>
    );
};
Actions.defaultProps = {
    label: 'Actions',
};

const ListActions = () => (
    <TopToolbar>
        <CreateButton />
    </TopToolbar>
);
const ListFilter = (props: any) => (
    <Filter {...props}>
        <TextInput label="Search" source="name" alwaysOn />
    </Filter>
);

const BulkUploadList = () => {
    const [openRowId, setOpenRowId] = useState<string | null>(null);
    const navigate = useNavigate();

    return (
        <List
            resource="bulk-uploads"
            sort={{ field: 'createdAt', order: 'DESC' }}
            actions={<ListActions />}
            filters={<ListFilter />}
            queryOptions={{
                refetchOnReconnect: false,
                refetchOnWindowFocus: false,
            }}
            empty={
                <NoDataSection
                    resource={'bulk-uploads'}
                    onCreate={() => {
                        navigate(`/bulk-uploads/create`);
                    }}
                />
            }
        >
            <Datagrid bulkActionButtons={false}>
                <TextField source="name" sortable={false} />
                <TextField source="type" />
                <FormattedDateTimeField source="createdAt" sortable={false} />
                <StatusTags source="status" label={'Status'} />
                <Actions openRowId={openRowId} setOpenRowId={setOpenRowId} />
            </Datagrid>
        </List>
    );
};

export default BulkUploadList;
